import React from "react";
import ProgramPage from "../../components/ProgramPage";

export default function GokSecondChance() {
    return (
        <ProgramPage
            eyebrow="A Program of The Gift of Kindness"
            title="GOK Second Chance Program"
            subtitle="Re-entry, redemption, and restoration."
            tagline="A mistake is not a life sentence."
            hero_image="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            intro="GOK Second Chance walks alongside men and women returning home from incarceration — believing that the person who steps out of a prison gate is not the same person who stepped in, and that grace has the last word."
            body_paragraphs={[
                "Coming home is one of the hardest days of a person's life. Family dynamics have shifted. Job applications look impossible. Judgment travels ahead of introduction. GOK Second Chance meets returning citizens in those first weeks with practical support and consistent friendship.",
                "We partner with employers, landlords, churches, and mentors to remove barriers and build bridges. Through pre-release correspondence, welcome-home care, job coaching, and community reintegration, we help our neighbors step into what's next with dignity.",
                "Every person is more than the worst thing they've ever done. This program is proof of that — and an invitation for the church and community to prove it, too.",
            ]}
            pillars={[
                { t: "Pre-Release Letters", b: "Handwritten correspondence in the months leading up to release — so no one comes home without a friend already waiting." },
                { t: "Welcome-Home Kits", b: "IDs, clothing, phones, hygiene, and a warm meal on day one — the practical scaffolding of a fresh start." },
                { t: "Mentor Matching", b: "Paired with a trained mentor who walks with them through the first 12 months of re-entry." },
            ]}
            verse={{
                text: "Therefore, if anyone is in Christ, the new creation has come: The old has gone, the new is here!",
                attribution: "2 Corinthians 5:17",
            }}
            cta_text="Become a Mentor"
        />
    );
}
